import { ActionType } from '@src/framework/editor/src/js/constants/common-action-type';
import BaseDrawerFeature from '@framework/workbench/common/feature/base-drawer-feature';
import { Feature, ColorFrom } from '@tencent/workbench';
import { FORM_CONFIGS } from '@framework/workbench/drawer/ui/table/border-color/config';
import { FormItemName } from '@framework/workbench/drawer/constants';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';
import { ColorSelectButton } from '@framework/workbench/drawer/components/color-select-button';
import { getDrawerColorOptions } from '@framework/workbench/drawer/utils/color-options';
import React from 'react';
import {
    TDWActionType, TDWVer5Type,
    TDWVer6Type,
} from '@src/slide/infrastructure/module/dependent/report/offline-data-report/constant';
import { ITDColor, TDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';

const DefaultBorderColor = '#000';

@Feature()
export class TableBorderColorFeature extends BaseDrawerFeature {
    id = ActionType.BORDERCOLOR;
    config = FORM_CONFIGS[0];

    public get borderColor(): ITDColor {
        const borderColor = (this.getSelectModel() as ITableModel).getBorder?.()
            .getBorderInfo()?.tdColor;
        return borderColor ? borderColor : new TDColor({ rgbaStr: DefaultBorderColor });
    }

    public handleColorChange = (tdColor: ITDColor, from: ColorFrom | number) => {
        let colorObj;
        const value = tdColor.srgb_color;
        if (value === 'transparent') {
            colorObj = { color: null };
        } else {
            colorObj = { color: value, tdColor };
        }
        (this.getSelectModel() as ITableModel).getBorder?.()
            .updateTableBorderInfo(colorObj);

        this.getColorPickerManager()?.colorPickerTdwReport({
            color: value,
            colorPickerFrom: TDWVer6Type.COLOR_PICKER_DRAWER,
            colorGroupFrom: from,
            actionType: TDWVer5Type.COLOR_PICKER_BORDER,
        });
    };

    public getColorSelectButton() {
        return <ColorSelectButton
            onColorChange={this.handleColorChange}
            value={this.borderColor}
            paletteButtonsStyle={{
                width: 116,
                marginLeft: 'auto',
            }}
            colorBoxStyle={{
                width: 88,
            }}
        />;
    }
}
